import { cableSelectionRequiredOfferings } from '../settings';

export const buildCableSelectionModules = function(module) {
    let cableSelectionModules = {};
    for (let product in cableSelectionRequiredOfferings) {
        for (let offer of cableSelectionRequiredOfferings[product]) {
            cableSelectionModules[`${product}${offer}CableSelection`] = {...module};
        }
    }
    return cableSelectionModules;
}

export const getModuleNamespace = function(store, state) {
	const moduleNamespace = Object.keys(store._modulesNamespaceMap).find(path => store._modulesNamespaceMap[path].context.state === state);
	if (typeof moduleNamespace === 'string') {
		return  moduleNamespace.slice(0, -1).split('/');
	}
}
